/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 计划断货日志列表-筛选项 的 **请求配置**
 *
 * @分类 采购API/计划
 * @请求头 `POST /erp/WcgPlanCancel/optionsForList`
 */
const postOptionsForListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgPlanCancel/optionsForList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOptionsForList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 计划断货日志列表-筛选项 的 **请求函数**
 *
 * @分类 采购API/计划
 * @请求头 `POST /erp/WcgPlanCancel/optionsForList`
 */
export const postOptionsForList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOptionsForListRequestConfig, requestData),
    ...args
  );
};
postOptionsForList.requestConfig = postOptionsForListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 急救箱列表-筛选项 的 **请求配置**
 *
 * @分类 采购API/急救箱
 * @请求头 `GET /erp/WcgPlanCancel/optionsForEmergencyBoxList`
 */
const getOptionsForEmergencyBoxListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgPlanCancel/optionsForEmergencyBoxList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForEmergencyBoxList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 急救箱列表-筛选项 的 **请求函数**
 *
 * @分类 采购API/急救箱
 * @请求头 `GET /erp/WcgPlanCancel/optionsForEmergencyBoxList`
 */
export const getOptionsForEmergencyBoxList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getOptionsForEmergencyBoxListRequestConfig, requestData),
    ...args
  );
};
getOptionsForEmergencyBoxList.requestConfig =
  getOptionsForEmergencyBoxListRequestConfig;
/**
 * 接口 急救箱列表 的 **请求配置**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/emergencyBoxList`
 */
const postEmergencyBoxListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgPlanCancel/emergencyBoxList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postEmergencyBoxList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 急救箱列表 的 **请求函数**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/emergencyBoxList`
 */
export const postEmergencyBoxList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postEmergencyBoxListRequestConfig, requestData),
    ...args
  );
};
postEmergencyBoxList.requestConfig = postEmergencyBoxListRequestConfig;
/**
 * 接口 恢复不断货 的 **请求配置**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/cancelOutOfStock`
 */
const postCancelOutOfStockRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgPlanCancel/cancelOutOfStock",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCancelOutOfStock",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 恢复不断货 的 **请求函数**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/cancelOutOfStock`
 */
export const postCancelOutOfStock = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCancelOutOfStockRequestConfig, requestData),
    ...args
  );
};
postCancelOutOfStock.requestConfig = postCancelOutOfStockRequestConfig;
/**
 * 接口 批量恢复不断货的商品列表 的 **请求配置**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/batchCancelOutOfStockGoodsList`
 */
const postBatchCancelOutOfStockGoodsListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgPlanCancel/batchCancelOutOfStockGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchCancelOutOfStockGoodsList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量恢复不断货的商品列表 的 **请求函数**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/batchCancelOutOfStockGoodsList`
 */
export const postBatchCancelOutOfStockGoodsList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchCancelOutOfStockGoodsListRequestConfig, requestData),
    ...args
  );
};
postBatchCancelOutOfStockGoodsList.requestConfig =
  postBatchCancelOutOfStockGoodsListRequestConfig;
/**
 * 接口 批量恢复不断货 的 **请求配置**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/batchCancelOutOfStock`
 */
const postBatchCancelOutOfStockRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgPlanCancel/batchCancelOutOfStock",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchCancelOutOfStock",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量恢复不断货 的 **请求函数**
 *
 * @分类 采购API/急救箱
 * @请求头 `POST /erp/WcgPlanCancel/batchCancelOutOfStock`
 */
export const postBatchCancelOutOfStock = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchCancelOutOfStockRequestConfig, requestData),
    ...args
  );
};
postBatchCancelOutOfStock.requestConfig =
  postBatchCancelOutOfStockRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 计划断货日志 的 **请求配置**
 *
 * @分类 旧接口文档/采购操作日志
 * @请求头 `POST /erp/WcgPlanCancel/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WcgPlanCancel/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 计划断货日志 的 **请求函数**
 *
 * @分类 旧接口文档/采购操作日志
 * @请求头 `POST /erp/WcgPlanCancel/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/wcgPlanCancel.js